module.exports = __webpack_public_path__ + "static/img/market-icon.51c160d4.png";